import { getImages } from "@repository/imagesRepository";
import { useQuery } from "react-query";

const useFetchImages = (lang: string) => {
  const { data, isLoading, isError } = useQuery(
    ["images"],
    () => getImages(lang),
    {
      refetchInterval: 1000 * 60 * 60,
    }
  );
  return { images: data, isLoading, isError };
};

export default useFetchImages;
